import styled from "styled-components";
import { SPACING } from "../../../constants/design/spacing";
import { BORDER_COLORS } from "../../../constants/design/colors";

export const MobileSelectWrapper = styled.div`
  padding: ${SPACING.two}px;
  border-top: 1px solid ${BORDER_COLORS.one};
  border-bottom: 1px solid ${BORDER_COLORS.one};
`;
